module.exports = __webpack_public_path__ + "img/高邑建材.484281a6.jpg";